export enum CategoryNames {
  COOKIE = "Cookie",
  CONTENT = "Kapcsolat",
  NEWS = "Hírek",
  HEADER = "Header",
  FOOTER = "Footer",
  EMATRICA_FAQ = "E-matrica Gyakran Ismételt Kérdések",
  HUGO_FAQ = "HU-GO Gyakran Ismételt Kérdések",
}
